import React, { Component } from "react";
import { connect } from "react-redux";
import { Container } from "reactstrap";
import { Link } from "react-router-dom";

import CustomLoader from "../../component/CustomLoader/CustomLoader";
import "./style.css";
import api from "../../config/api";
import historyAction from "../../redux/history/action";
import privacyPolicyAction from "../../redux/privacyPolicy/action";

class PrivacyPolicy extends Component {
  state = {
    isLoading: false,
    privacyPolicy: ""
  };

  componentDidMount() {
    const { history, setHistory, privacyPolicy } = this.props;

    if (!privacyPolicy) {
      this.getPrivacyPolicy();
    }

    setHistory(history);
  }

  getPrivacyPolicy = async () => {
    const { setPrivacyPolicy } = this.props;

    try {
      this.setState({ isLoading: true });

      const response = await api.fetchPrivacyPolicy();
      let data = response.data.PrivacyClause;
      data = data.replace(/\n/g, "<br />");
      setPrivacyPolicy(data);
      this.setState({ privacyPolicy: data });
    } catch (e) {
      console.log("e =>", e);
    }
    this.setState({ isLoading: false });
  };

  render() {
    const { isLoading } = this.state;
    const { privacyPolicy } = this.props;

    return (
      <div>
        <div className="p-2 text-center privacy-sticky-back-to-home">
          <Link to="/login">
            Back to Login
          </Link>
        </div>
        <Container className="py-4">
          {privacyPolicy && (
            <p dangerouslySetInnerHTML={{ __html: privacyPolicy }} />
          )}
        </Container>
        {isLoading && <CustomLoader text="Please wait" />}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  privacyPolicy: state.privacyPolicy.privacyPolicy
});

const mapDispatchToProps = {
  setHistory: historyAction.setHistory,
  setPrivacyPolicy: privacyPolicyAction.setPrivacyPolicy
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PrivacyPolicy);
